<app-dialog-content>
  <div class="p-grid">
    <div
      [innerHtml]="content"
      class="p-col-12"
    >
    </div>
  </div>
</app-dialog-content>
<div class="dialog-footer">
  <ui-hidden-button></ui-hidden-button>
  @if (!confirmed) {
    <button
      (click)="reject()"
      data-qa="terms-of-use-reject-button"
      type="button"
      class="proget-button text-only"
    >
      {{ 'button.do_not_accept.label' | translate }}
    </button>
  }
  @if (!confirmed) {
    <button
      (click)="accept()"
      data-qa="terms-of-use-accept-button"
      type="button"
      class="proget-button text-only primary-button"
    >
      {{ 'button.accept.label' | translate }}
    </button>
  }
  @if (confirmed) {
    <button
      (click)="close()"
      data-qa="terms-of-use-close-button"
      type="button"
      class="proget-button text-only"
    >
      {{ 'button.close.label' | translate }}
    </button>
  }
</div>
